import React from "react";
import { FaTools, FaUser, FaInfoCircle } from "react-icons/fa";

// Son güncelleme zamanını formatla
export const formatDate = (date) => {
  if (!date) return "Bilinmiyor";
  const d = new Date(date);
  return `${d.toLocaleDateString("tr-TR")} ${d.toLocaleTimeString("tr-TR")}`;
};

// Gün sayısını hesapla
export const calculateDaysAgo = (date) => {
  if (!date) return "Bilinmiyor";
  const now = new Date();
  const past = new Date(date);
  const diffTime = Math.abs(now - past);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return `${diffDays} gün önce`;
};

// Cihaz türüne göre ikon belirleme
export const getDeviceTypeIcon = (deviceStatusName) => {
  if (deviceStatusName === "Servis") {
    return <FaTools className="text-orange-500 w-5 h-5" />;
  } else if (deviceStatusName === "Plasiyer") {
    return <FaUser className="text-blue-500 w-5 h-5" />;
  }
  return <FaInfoCircle className="text-gray-500 w-4 h-4" />;
};

// Uzun süredir bu durumda duran cihaz kırmızı yanıp söner (#80).
// Gün eşikleri; contract: docs/api-contracts/device-status-since.md
export const STALE_STATUS_DAYS = { Servis: 7, Plasiyer: 7 };
const DAY_MS = 24 * 60 * 60 * 1000;

// Durumda geçen tam gün; tarih yoksa/geçersizse null
export const daysInStatus = (since, now = Date.now()) => {
  if (!since) return null;
  const t = new Date(since).getTime();
  if (Number.isNaN(t)) return null;
  return Math.max(0, Math.floor((now - t) / DAY_MS));
};

export const isStaleStatus = (statusName, since, now = Date.now()) => {
  const limit = STALE_STATUS_DAYS[statusName];
  if (!limit) return false;
  const days = daysInStatus(since, now);
  return days !== null && days >= limit;
};
